import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import api, { apiError } from "../../lib/api";

const EMPTY = { title: "", body: "", link: "", audience: "all" };

export default function BroadcastTab() {
  const [form, setForm] = useState(EMPTY);
  const [history, setHistory] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/broadcasts").then((r) => setHistory(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const send = async () => {
    if (!form.title.trim()) return toast.error("Title is required");
    if (!window.confirm(`Send this notification to ${form.audience === "all" ? "ALL users" : `all ${form.audience}s`}?`)) return;
    setBusy(true);
    try { const r = await api.post("/admin/broadcast", form); toast.success(r.data.message); setForm(EMPTY); load(); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="nb p-6">
        <h3 className="font-display font-extrabold mb-4 flex items-center gap-2"><Megaphone className="w-5 h-5" /> Send Broadcast Notification</h3>
        <div className="space-y-3">
          <div><label className="nb-label">Audience</label>
            <select data-testid="broadcast-audience-select" value={form.audience} onChange={set("audience")} className="nb-input mt-1.5">
              <option value="all">Everyone</option>
              <option value="institute">Institutes only</option>
              <option value="student">Students only</option>
            </select></div>
          <div><label className="nb-label">Title</label>
            <input data-testid="broadcast-title-input" value={form.title} onChange={set("title")} className="nb-input mt-1.5" /></div>
          <div><label className="nb-label">Message</label>
            <textarea data-testid="broadcast-body-input" rows={4} value={form.body} onChange={set("body")} className="nb-input mt-1.5" /></div>
          <div><label className="nb-label">Link (optional, e.g. /institutes)</label>
            <input data-testid="broadcast-link-input" value={form.link} onChange={set("link")} className="nb-input mt-1.5" /></div>
          <button data-testid="broadcast-send-btn" disabled={busy} onClick={send} className="nb-btn nb-btn-lime">{busy ? "Sending…" : "Send to app"}</button>
          <p className="text-xs text-slate-500">Recipients see it instantly in the bell icon inside the app.</p>
        </div>
      </div>
      <div className="space-y-3">
        <h3 className="font-display font-extrabold">Sent history</h3>
        {history.length === 0 && <p className="text-sm text-slate-500">No broadcasts yet.</p>}
        {history.map((b) => (
          <div key={b.id} data-testid={`broadcast-row-${b.id}`} className="nb p-4">
            <p className="font-bold text-sm">{b.title}</p>
            {b.body && <p className="text-xs text-slate-600 mt-1">{b.body}</p>}
            <p className="text-[11px] text-slate-400 mt-1 capitalize">{b.audience} · {b.recipients} recipients · {new Date(b.created_at).toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
